import { WidgetResources } from "./widget";

const resources: WidgetResources = {
  documentCentre: {
    components: {
      searchBarTitle: "Forms and guides",
      documentCentreTitle: "Document Centre"
    },
    tabs: {
      searchLabel: "Search",
      favouriteLabel: "Favourite"
    },
    favourites: {
      titleLabel: "Favourite",
      unavailableMessage: "Actions on the favourites are not available at the moment. Please try again later.",
      moveUpTooltip: "Move up the list",
      moveDownTooltip: "Move down the list",
      removeTooltip: "Remove from the list",
      showAllLabel: "All favourites",
      showAllLabelInd: "View all favourites",
      errorMessage: "Unable to retrieve favourite documents.",
      noDocumentMessage: "No favourite document found. To add a document to favourites, click on the « Add to favourites » icon next to each document search result."
    }
  },
  news: {
    titleLabel: "News",
    buttonLabel: "All the news"
  },
  login: {
    title: "Secure access",
    submitButton: "Sign in",
    registrationLabel: "Register"
  },
  application: {
    titleLabel: "Tools and applications"
  },
  promotion: {
    correspondenceLanguageEnglish: "English",
    correspondenceLanguageFrench: "French",
    emailHome: "Home",
    emailWork: "Work",
    phoneNumberCell: "Cell",
    phoneNumberFax: "Fax",
    phoneNumberHome: "Home",
    phoneNumberWork: "Work"
  },
  contract: {
    title: "Search",
    subTitle: "All the contracts of",
    newSearch: "New search"
  },
  contractList: {
    noContractTitle: "Contract no.",
    descriptionTitle: "Description",
    returnButton: "Return to client"
  },
  instabilityMessage: {
    baseMessage: "Please take note that some sections are currently unavailable. We apologize for the inconvenience.",
    investiaAdvisorMessage: `Please take note that some sections are currently unavailable. We apologize for the inconvenience.<br/>
                                 Meanwhile, you can access Univeris by clicking this link:  <a href="https://investia.iaas.ca">Univeris</a>`,
    fundexAdvisorMessage: `Please take note that some sections are currently unavailable. We apologize for the inconvenience.<br/>
                               Meanwhile, you can access Univeris by clicking this link:  <a href="https://advisor.fundex.com/upm">Univeris</a>`,
    iaAdvisorMessage: `Please take note that some sections are currently unavailable, specifically the documentation access. We are working
                           to resolve the situation. We apologize for the inconvenience.<br/>Thank you for your understanding.`
  }
};
export default resources;